<div
  class="flex flex-col rounded-md border border-gray-200 bg-white p-4"
  [formGroup]="passwordForm"
>
  <h2 class="mb-4 text-lg text-primary-500">
    {{ "accountMenu.password.title" | transloco }}
  </h2>

  <!-- CURRENT PASSWORD -->
  <div class="mb-2 flex max-w-80 flex-col">
    <label for="currentPassword" class="text-sm font-semibold text-greyscale-600">{{
      "accountMenu.password.currentPassword" | transloco
    }}</label>
    <p-password
      id="currentPassword"
      autocomplete="new-password"
      [fluid]="true"
      [placeholder]="
        'accountMenu.password.placeholder.currentPassword' | transloco
      "
      formControlName="currentPassword"
      [toggleMask]="true"
      [feedback]="false"
      data-testid="current.password.input"
    ></p-password>
    <div
      class="text-xs text-red-500"
      [ngClass]="
        isInvalid('currentPassword') &&
        getControlErrors('currentPassword').includes('required')
          ? 'visible'
          : 'invisible'
      "
    >
      {{ "validationError.required" | transloco }}
    </div>
  </div>

  <!-- NEW PASSWORD -->
  <div class="mb-2 flex max-w-80 flex-col">
    <label for="newPassword" class="text-sm font-semibold text-greyscale-600">{{
      "accountMenu.password.newPassword" | transloco
    }}</label>

    <p-password
      id="newPassword"
      [placeholder]="'resetPasswordPage.newPassword' | transloco"
      formControlName="newPassword"
      [toggleMask]="true"
      [fluid]="true"
      [strongRegex]="
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})'
      "
      data-testid="new.password.input"
    >
      <ng-template #header>
        <div class="text-xm mb-4 font-semibold">
          {{ "resetPasswordPage.pickPassword" | transloco }}
        </div>
      </ng-template>
      <ng-template #footer>
        <p-divider />
        <ul class="my-0 ml-2 pl-2 leading-normal">
          <li>
            {{ "resetPasswordPage.lowercase" | transloco }}
          </li>
          <li>
            {{ "resetPasswordPage.uppercase" | transloco }}
          </li>
          <li>
            {{ "resetPasswordPage.numeric" | transloco }}
          </li>
          <li>
            {{ "resetPasswordPage.special" | transloco }}
          </li>
          <li>
            {{ "resetPasswordPage.length" | transloco }}
          </li>
        </ul>
      </ng-template>
    </p-password>
    <div
      class="text-xs text-red-500"
      [ngClass]="isInvalid('newPassword') ? 'visible' : 'invisible'"
    >
      @if (getControlErrors("newPassword").includes("required")) {
        {{ "validationError.required" | transloco }}
      } @else if (
        getControlErrors("newPassword").includes("passwordStrength")
      ) {
        {{ "validationError.passwordStrength" | transloco }}
      }
    </div>
  </div>
  <!-- CONFIRM PASSWORD -->
  <div class="mb-2 flex max-w-80 flex-col">
    <label for="confirmPassword" class="text-sm font-semibold text-greyscale-600">{{
      "accountMenu.password.confirmNewPassword" | transloco
    }}</label>
    <p-password
      [fluid]="true"
      [placeholder]="'resetPasswordPage.confirmPassword' | transloco"
      formControlName="confirmPassword"
      [toggleMask]="true"
      [feedback]="false"
      data-testid="confirm.password.input"
    ></p-password>
    <div
      class="text-xs text-red-500"
      [ngClass]="notMatchingError ? 'visible' : 'invisible'"
    >
      {{ "validationError.notMatching" | transloco }}
    </div>
  </div>
  <div class="flex justify-start">
    <p-button
      type="button"
      (click)="onSubmit()"
      [disabled]="passwordForm.invalid"
      data-testid="update.password.button"
    >
      <lucide-angular [img]="lockIcon" class="mr-2 h-4 w-4" />
      <span class="font-semibold">{{ "accountMenu.updatePassword" | transloco }}</span>
    </p-button>
  </div>
</div>
